import { motion } from "framer-motion";
import ContactSection from "./contact-section";
import FeaturesSection from "./features-section";
import Footer from "./footer";
import HeroSection from "./hero-section";
import HowItWorksSection from "./how-it-works-section";
import PricingSection from "./pricing-section";

// import TestimonialsSection from "./testimonials-section";

function AnimateOnScroll({ children, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px" }}
      transition={{ duration: 0.7, ease: "easeOut" }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

function LandingPage() {
  return (
    <>
      <main>
        <HeroSection />
        <AnimateOnScroll>
          <HowItWorksSection />
        </AnimateOnScroll>
        <AnimateOnScroll>
          <FeaturesSection />
        </AnimateOnScroll>
        <AnimateOnScroll>
          <PricingSection />
        </AnimateOnScroll>
        {/* <AnimateOnScroll>
          <TestimonialsSection />
        </AnimateOnScroll> */}
        <AnimateOnScroll>
          <ContactSection />
        </AnimateOnScroll>
      </main>
      <Footer />
    </>
  );
}

export default LandingPage;
